import _objectSpread from "/Users/oleksandrlevinskyi/code/meaningful-careers/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { setContext, init as init$1 } from '@sentry/browser';
import { applySdkMetadata } from '@sentry/core';
import { version } from 'react';

/**
 * Inits the React SDK
 */
function init(options) {
  var opts = _objectSpread({}, options);
  applySdkMetadata(opts, 'react');
  setContext('react', {
    version: version
  });
  return init$1(opts);
}
export { init };